// extracted by mini-css-extract-plugin
export default {"wrapper":"TotalForm_wrapper__K5Gdh","form":"TotalForm_form__0xV6h","wrapperHead":"TotalForm_wrapperHead__A7khs","wrapperForm":"TotalForm_wrapperForm__92Fsn"};